import * as angular from 'angular';
import * as _ from 'lodash';
import { ThunkDispatch } from 'redux-thunk';

import * as VALUE_VIEW_MODELS from './valueViewModels.constants';
import { IIdentifierVmService } from '../../services';
import { Store } from '../Store';
import { IValueViewModel } from '../../models';
import { loadValueViewModels, loadValueViewModelsSuccess, loadValueViewModelSuccess } from './valueViewModels.actions';

export interface IValueViewModelActionsService {
    getOne(guid: string): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel>;
    getOne(guid: string, force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel>;
    // get(guids: string[]): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]>;
    // get(guids: string[], force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]>;
    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]>;
}

export class ValueViewModelActionsService implements IValueViewModelActionsService {
    static serviceId = 'valueViewModelActionsService';

    static $inject = [
        '$q',
        'identifierVmService'
    ];

    constructor(
        private _$q: angular.IQService,
        private _identifierVmService: IIdentifierVmService
    ) {
    }

    getOne(guid: string, force: boolean = false): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel> {
        if (force) {
            this._identifierVmService.cleanCache([guid]);
        }
        return (dispatch: ThunkDispatch<any, any, any>, getState: () => Store) => {
            return this._identifierVmService.getViewModelsFromApiFromGuidList([guid])
                .then(data => {
                    const result = data[0];
                    dispatch(loadValueViewModelSuccess(result));
                    return result;
                })
                .catch(reason => {
                    dispatch({ type: VALUE_VIEW_MODELS.VALUE_VIEW_MODEL_LOAD_ERROR, payload: reason });
                    return reason;
                });
        };
    }

    // get(guids: string[]): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]>;
    // get(guids: string[], force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]>;
    // get(guids: string[], force?: boolean) {
    //     if (force) {
    //         this._identifierVmService.cleanCache(guids);
    //     }
    //     return (dispatch: ThunkDispatch<any, any, any>, getState: () => Store) => {
    //         const current = (Object as any).assign({}, getState().valueViewModels.dictionary);
    //         return this._identifierVmService.getViewModelsFromApiFromGuidList(guids)
    //             .then(data => {
    //                 data.forEach(d => current[d.guid] = d);
    //                 dispatch(loadValueViewModelsSuccess(_.values(current)));
    //                 return data;
    //             })
    //             .catch(reason => {
    //                 dispatch({ type: VALUE_VIEW_MODELS.VALUE_VIEW_MODEL_LOAD_ERROR, payload: reason });
    //                 return reason;
    //             });
    //     };
    // }

    getAll(): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]>;
    getAll(force: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]>;
    getAll(force?: boolean): (dispatch: any, getState: () => Store) => angular.IPromise<IValueViewModel[]> {
        return (dispatch: ThunkDispatch<any, any, any>, getState: () => Store) => {
            const { valueViewModels } = getState();
            if (force || (!valueViewModels.isLoading && !valueViewModels.isLoaded)) {
                dispatch(loadValueViewModels());
                return this._identifierVmService.getAllViewModels(force)
                    .then(data => {
                        dispatch(loadValueViewModelsSuccess(data));
                        return data;
                    })
                    .catch(reason => {
                        dispatch({ type: VALUE_VIEW_MODELS.VALUE_VIEW_MODELS_LOAD_ERROR, payload: reason });
                        return reason;
                    });
            } else {
                return this._$q.when(_.values(valueViewModels.dictionary));
            }
        };
    }

}